import React from 'react';
import '../../css/Start.css';
import { Link } from 'react-router-dom';

const StartSection = () => {
  // Check if user is logged in using localStorage
  const isLoggedIn = !!localStorage.getItem('authToken');

  // Decide the destination link
  const destination = isLoggedIn ? '/employee-attendance' : '/login';

  return (
    <section
      className="section-start"
      style={{
        backgroundImage: 'url("/images/h-1.jpg")',
      }}
    >
      <div className="container">
        <div className="inner-content">
          <div className="content-box">
            <div className="img-box">
              <img src="/images/site-logo.png" alt="Site Logo" />
            </div>
            <div className="btn-001">
              <Link to={destination}>Let's get started</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartSection;
